import React, { useEffect } from 'react';
import PageHeader from '../components/PageHeader';

const ContactPage = () => {
  useEffect(() => {
    document.title = "Contact Snap Launch Studio | Schedule a Call or Send a Message";
  }, []);

  return (
    <>
      <PageHeader 
        title="Let's Build Your Dream Website" 
        subtitle="Get in touch to see a personalized website prototype and start generating more leads for your business"
      />
      
      <section className="py-16 bg-white">
        <div className="container">
          <div className="max-w-4xl mx-auto">
            {/* Stacked full-width layout */}
            
            {/* Booking Calendar - First */}
            <div className="glass-card p-8 mb-12">
              <h3 className="text-2xl font-semibold mb-6" id="booking-calendar">Book a 10-Minute Call</h3>
              <p className="mb-6">
                Schedule a quick call to see your custom website prototype and discuss how we can help your business start generating more leads. No commitment required.
              </p>
              
              <div className="w-full" style={{ height: "800px", minHeight: "800px" }}>
                <div dangerouslySetInnerHTML={{ 
                  __html: `<iframe src="https://api.snaplaunchstudio.com/widget/booking/a5aqjCaQnDgk9IcrHRis" style="width: 100%;height:800px;min-height:800px;border:none;overflow: hidden;" scrolling="no" id="a5aqjCaQnDgk9IcrHRis_1749241597217"></iframe>`
                }} />
              </div>
            </div>
            
            {/* Contact Form - Second */}
            <div className="glass-card p-8">
              <h3 className="text-2xl font-semibold mb-6">Send Us a Message</h3>
              <p className="mb-6">
                Have questions or prefer to communicate via email? Fill out the form below and we'll get back to you within 24 hours.
              </p>
              
              <div style={{ height: "903px" }}>
                <div dangerouslySetInnerHTML={{ 
                  __html: `<iframe
src="https://api.snaplaunchstudio.com/widget/form/m70UNopdwI3LB7oZbdLM"
style="width:100%;height:100%;border:none;border-radius:4px"
id="inline-m70UNopdwI3LB7oZbdLM" 
data-layout="{'id':'INLINE'}"
data-trigger-type="alwaysShow"
data-trigger-value=""
data-activation-type="alwaysActivated"
data-activation-value=""
data-deactivation-type="neverDeactivate"
data-deactivation-value=""
data-form-name="Contact Form"
data-height="903"
data-layout-iframe-id="inline-m70UNopdwI3LB7oZbdLM"
data-form-id="m70UNopdwI3LB7oZbdLM"
title="Contact Form"
>
</iframe>`
                }} />
              </div>
            </div>
            
          </div>
        </div>
      </section>
    </>
  );
};

export default ContactPage;
